import { useState } from 'react';
import { toast } from '@acast-tech/decibel';

export interface ModalDownloadResult {
  warningMessage?: string;
}

/**
 * This hook is used to handle the download of data from a modal.
 *
 * @param modalDateRange - The date range of the modal.
 * @returns The download state and the function to handle the download.
 */
const useModalDownload = () => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const handleDownload = async (downloadFn: () => Promise<ModalDownloadResult | void>) => {
    setIsDownloading(true);
    try {
      const result = await downloadFn();
      if (result?.warningMessage) {
        toast.warning(result.warningMessage);
      }
    } catch (error) {
      console.error('Error downloading data', error);
      toast.danger('Failed to download data');
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, handleDownload };
};

export default useModalDownload;
